import { SearchRequestInstrumentation } from 'owa-search-service';

// We'll only log the last N entries
const MAX_ENTRIES_TO_LOG = 100;

export default function insertInstrumentationInList(
    searchRequestDatapoint: SearchRequestInstrumentation,
    datapointList: SearchRequestInstrumentation[]
) {
    const searchQueryId = searchRequestDatapoint.SearchQueryId;

    // Find place to insert datapoint in list. We want search query entries to be in reverse order,
    // but the page numbers to be in sequential order for a specific query, so scan the datapoint list
    // until we hit a non-matching query, where we'll add the last datapoint for the previous query.
    let lastMatchingQueryIndex = -1;
    for (let i = datapointList.length - 1; i >= 0; i--) {
        if (datapointList[i].SearchQueryId == searchQueryId) {
            lastMatchingQueryIndex = i;
            break;
        }
    }

    let indexToInsert;
    if (lastMatchingQueryIndex == -1) {
        // If no existing entries matching query Id, insert at the top of the list
        indexToInsert = 0;
    } else {
        // Otherwise append to the end of the existing query list
        indexToInsert = lastMatchingQueryIndex + 1;
    }

    datapointList.splice(indexToInsert, 0, searchRequestDatapoint);

    // Truncate entries past max
    if (datapointList.length > MAX_ENTRIES_TO_LOG) {
        datapointList.splice(MAX_ENTRIES_TO_LOG);
    }
}
